import ScanAssignDTO from '@src/adapters/dto/scan/ScanAssignDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {}

interface Result {
  scans: ScanAssignDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/scan/unassigned',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindScansUnassigned = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindScansUnassignedLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindScansUnassigned;
